define('SageDotCom/Components/Content/Buttons/CcaasButton',["jquery", "SageDotCom/DataLayer/Events/Ccaas/ccaasAltEvent", "SageDotCom/DataLayer/Events/Ccaas/ccaasTracking", "eventManager"],
    function ($, CcaasAltEvent, CcaasTracking, eventManager) {
        function CcaasButton(hidePreChatForm) {
            if (typeof SageWebChatApi === "undefined") {
                $(".ccaas-container").hide();
                return;
            }
        }

        CcaasButton.init = function init(args) {
            return args.IsExperienceEditorEditing ? null : new CcaasButton(args.hidePreChatForm);
        };

        return CcaasButton;
    });

